import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface ReplyCommentDialogDialogData {
  title: string;
  body: string;
  email: string;
  date: Date;
}

@Component({
    selector: "app-reply-comment-dialog",
    templateUrl: "./ReplyCommentDialog.component.html",
    styleUrls: ["./ReplyCommentDialog.component.scss"],
    standalone: false
})
export class ReplyCommentDialog {
  constructor(
    public dialogRef: MatDialogRef<ReplyCommentDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ReplyCommentDialogDialogData
  ) {}
}
